module.exports = __webpack_public_path__ + "static/media/Ithra.017d998a.png";